<template>
  <div>
    <!-- Search begin -->
    <div class="te-search">
      <!-- 錯誤加border-danger -->
      <div class="search-item input-box">
        <input v-model="search" type="text" placeholder="輸入搜尋關鍵字" @keypress.enter="submit">
      </div>
      <div class="search-item">
        <a v-if="(search || '') !== ''" class="icon" href="#" @click="clear">
          <i class="material-icons font-size-md" title="清除">
            close
          </i>
        </a>
        <a class="icon p-0" href="#" @click="submit">
          <i class="material-icons" title="搜尋">
            search
          </i>
        </a>
      </div>
    </div>
    <div class="mt-1 text-danger font-size-sm" style="display:none">
      錯誤訊息錯誤訊息錯誤訊息
    </div>
  <!-- Search end -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      search: ''
    };
  },
  methods: {
    clear() {
      this.search = '';
      this.submit();
    },
    submit() {
      this.$emit('search', this.search);
    }
  }
};
</script>
